import { IProject } from '@relab/alstom-ptw-shared';
import React, { FC, useState } from 'react';
import { Button, Checkbox, Grid, GridRow, Header, Icon, Modal, ModalActions, ModalContent } from 'semantic-ui-react';
import { TranslationComponent } from '../TranslationComponent';
import { useTranslation } from 'react-i18next';
import { projectCreateAction } from '../../redux/actions';
import { connect } from 'react-redux';

type Props = {
  project: IProject;
  projectCreateAction: typeof projectCreateAction;
};

const PProjectCloneModal: FC<Props> = ({ project, projectCreateAction }) => {
  const { t } = useTranslation();

  const [showModal, setShowModal] = useState(false);
  const [cloneAssignees, setCloneAssignees] = useState(true);
  const [cloneVehicles, setCloneVehicles] = useState(false);

  const handleCloneProject = () => {
    projectCreateAction({
      name: `${project.name} - ${t('copy')}`,
      assignees: cloneAssignees ? project.assignees : [],
      trains: cloneVehicles ? project.trains : [],
    });

    setShowModal(false);
  };

  return (
    <Modal
      open={showModal}
      onClose={() => setShowModal(false)}
      trigger={
        <Button icon onClick={() => setShowModal(true)}>
          <Icon name="clone" />
        </Button>
      }
    >
      <Header>
        <TranslationComponent stringKey={'Clone Project'} />
      </Header>

      <ModalContent>
        <Grid style={{ margin: 0 }}>
          <GridRow>
            <Checkbox
              label={t('Users and roles')}
              checked={cloneAssignees}
              onChange={() => setCloneAssignees((prev) => !prev)}
              disabled
            />
          </GridRow>

          {/*<GridRow>*/}
          {/*  <Checkbox label={t('Vehicles')} checked={cloneVehicles} onClick={() => setCloneVehicles((prev) => !prev)} />*/}
          {/*</GridRow>*/}
        </Grid>
      </ModalContent>

      <ModalActions>
        <Button onClick={() => setShowModal(false)}>
          <TranslationComponent stringKey={'Cancel'} />
        </Button>

        <Button primary type="button" onClick={handleCloneProject}>
          <TranslationComponent stringKey={'Confirm'} />
        </Button>
      </ModalActions>
    </Modal>
  );
};

export const ProjectCloneModal = connect(null, { projectCreateAction })(PProjectCloneModal);
